import React, { useEffect } from "react";
import "../OrderSalesReport.css";
import Logo from "../../../assets/images/logo.png";
import { getSalesReportOrderPrint } from "../../../redux/actions/salesReport.action";
import { getPickTicketPrint } from "../../../redux/actions/pickTicketReport.action";
import { useSelector } from "react-redux";
import { ReadCookie } from "../../../utils/readCookie";
import { useDispatch } from "react-redux";
import moment from "moment";

const OrderReportHeader = () => {
  const token = ReadCookie("token");
  const menuId = ReadCookie("menuId");
  const dispatch = useDispatch();
  const { salesReportOrderPrint, PickTicketPrint, newPTReport } = useSelector(
    (state) => state
  );

  const headerData = newPTReport && newPTReport?.payload?.data[0];

  return (
    <div className="sales-report">
      <div className="sales-report-header">
        {/* header Left */}
        <div className="header-left-side ">
          {/* Logo & Text */}
          <div className="sales-report-Logo-Container">
            <div>
              <img width={250} height={72} src={Logo} />
            </div>
            {/* Logo Items */}
            <div className="sales-report-Logo_items">
              <div>DL1961 Premium Denim Inc</div>
              <div>121 Varick Street,4th Floor</div>
              <div>New York NY 10013, USA</div>
              <div>TEL : (646) 514-9736</div>
              <div>FAX : (212) 991-9989</div>
              <div>DUNS # : 827403291</div>
            </div>
            {/* Logo Items */}
          </div>
          {/* Items details */}
          <div className="items-detail-container">
            {/* Sold To */}
            {/* <div className="sold-to-Container">
              <div className="sold-to">
                <div className="font_weight">Sold To :</div>
                <div className="sold-to-data">{headerData && headerData.bill_to_customer}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Name :</div>
                <div className="sold-to-data">{headerData && headerData.customer_name}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Address 1 :</div>
                <div className="sold-to-data">{headerData && headerData.bill_to_address_1}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Address 2 :</div>
                <div className="sold-to-data">{headerData && headerData.bill_to_address_2}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight">City :</div>
                <div className="sold-to-data">{headerData && headerData.bill_to_city_name}</div>
                <div className="font_weight">State :</div>
                <div className="sold-to-data">{headerData && headerData.bill_to_state_name}</div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Country :</div>
                <div className="sold-to-data">{headerData && headerData.bill_to_country}</div>
                <div className="font_weight">ZIP :</div>
                <div className="sold-to-data">{headerData && headerData.bill_to_zip}</div>
              </div> */}

            {/* </div> */}
            {/* Sold To */}
            {/* Ship To */}
            <div className="ship-to-Container">
              <div className="sold-to">
                <div className="font_weight">Ship To :</div>
                <div className="sold-to-data">
                  {headerData && headerData.ship_to_addressee}
                </div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Name :</div>
                <div className="sold-to-data">
                  {headerData && (headerData.shipping_firstname ? headerData.shipping_firstname + " " + headerData.shipping_lastname : headerData.ship_to_addressee)}
                </div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Address 1 :</div>
                <div className="sold-to-data">
                  {headerData && headerData.ship_to_address_1}
                </div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Address 2 :</div>
                <div className="sold-to-data">
                  {headerData && headerData.ship_to_address_2}
                </div>
              </div>
              <div className="sold-to">
                <div className="font_weight">City :</div>
                <div className="sold-to-data">
                  {headerData && headerData.ship_to_city_name}
                </div>
                <div className="font_weight">State :</div>
                <div className="sold-to-data">
                  {headerData && headerData.ship_to_state_name}
                </div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Country :</div>
                <div className="sold-to-data">
                  {headerData && headerData.ship_to_country_name}
                </div>
                <div className="font_weight">ZIP :</div>
                <div className="sold-to-data">
                  {headerData && headerData.ship_to_zip}
                </div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Dept :</div>
                <div className="sold-to-data">
                  {headerData && headerData.department}
                </div>
                <div className="font_weight">DC #</div>
                <div className="sold-to-data">
                  {headerData && headerData.dc_no}
                </div>
                <div className="font_weight">Store :</div>
                <div className="sold-to-data">
                  {headerData && headerData.store_name}
                </div>
              </div>
              <div className="sold-to">
                <div className="font_weight">Contact :</div>
                <div className="sold-to-data">
                  {headerData && headerData.customer_phone}
                </div>
                <div className="font_weight">Email :</div>
                <div className="sold-to-data">
                  {headerData && headerData.customer_email}
                </div>
              </div>
            </div>
            {/* Ship To */}
          </div>
          {/* Items details */}
        </div>
        {/* header Left */}
        {/* header Right */}
        <div className="header-right-side">
          <div className="sales-order-heading">Pick Ticket</div>
          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">PT# :</div>
            </div>
            <div className="sales_order_content">
              <div>{headerData && headerData.ship_header_no}</div>
            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">PT Date :</div>
            </div>
            <div className="sales_order_content">
              <div>
                {headerData &&
                  moment(headerData.ship_date).format("MM-DD-YYYY")}
              </div>
            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Sales Person :</div>
            </div>
            <div className="sales_order_content">
              <div>{headerData && headerData.sales_person_name}</div>
            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">P.O # :</div>
            </div>
            <div className="sales_order_content">
              <div>{headerData && headerData.po_number}</div>
            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Term :</div>
            </div>
            <div className="sales_order_content">
              <div>{headerData && headerData.term}</div>
            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Ship Method :</div>
            </div>
            <div className="sales_order_content">
              <div className="overflow_txt">
                {headerData && headerData.ship_via}
              </div>
            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Frieght Terms :</div>

            </div>
            <div className="sales_order_content">
              <div>{headerData && headerData.frieght_terms}</div>

            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Ship Date(From) :</div>

            </div>
            <div className="sales_order_content">
              <div>
                {headerData &&
                  moment(headerData.ship_date_from).format("MM-DD-YYYY")}
              </div>

            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Ship Date(To) :</div>
            </div>
            <div className="sales_order_content">
              <div>
                {headerData &&
                  moment(headerData.ship_date_to).format("MM-DD-YYYY")}
              </div>
            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Cancel Date :</div>

            </div>
            <div className="sales_order_content">
              <div>
                {headerData &&
                  moment(headerData.cancel_date).format("MM-DD-YYYY")}
              </div>
              
            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Order # :</div>

            </div>
            <div className="sales_order_content">
              <div>{headerData && headerData.sale_order_no}</div>

            </div>
          </div>

          <div className="sales-order-items-container">
            <div className="sales-order-items-left">
              <div className="font_weight">Order Date :</div>
            </div>
            <div className="sales_order_content">
              <div>
                {headerData &&
                  moment(headerData.order_date).format("MM-DD-YYYY")}
              </div>
            </div>
          </div>
        </div>
        {/* header Right */}
      </div>
    </div>
  );
};

export default OrderReportHeader;
